export const HrmsSyncStates = {
  IN_PROGRESS: "in-progress",
  EXPIRED: "expired",
  COMPLETED: "completed",
  FAILED: "failed",
};
